<cm-info-section title="Organization Admins">
    <div class="admin-info">
        <cm-profile-avatar
            class="avatar"
            imageUrl=""
            placeholder="/assets/images/user-icon-colored.svg"
        ></cm-profile-avatar>
        {{ label }}
    </div>
</cm-info-section>
